(function () {
  'use strict';
  // Pizza-night add-ons: offer rules are evaluated by UpsellPlus, not the retired cookie campaign.
  // Retain legacy event/global names because the existing renderer and Route adapter share them.
  window.gioPizzaNightOfferId = 'LCDgeaJ5ySz3SWImzsk9';
  if (location.pathname !== '/products/giordanos-deep-dish-pizza-packs') return;
  const rendererUrl = document.currentScript.dataset.popupRenderer;
  const checkoutSelector = 'button[name="checkout"], [data-route-cloned-button], [data-checkout-without-coverage-link]';
  let rendererLoaded = false;
  let busy = false;
  let replay = false;
  let navigating = false;
  let activeButton;
  let uncovered = false;

  function unmount() {
    const popup = window.GioCookieCartPopup;
    popup?._root?.unmount();
    if (popup) popup._initialized = false;
  }

  function activate() {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => { window.removeEventListener('gio-cookie-popup-ready', ready); reject(new Error('Popup unavailable')); }, 8000);
      function ready(event) {
        clearTimeout(timeout);
        window.removeEventListener('gio-cookie-popup-ready', ready);
        resolve(event.detail.hasOffer);
      }
      window.addEventListener('gio-cookie-popup-ready', ready);
      if (rendererLoaded) {
        unmount();
        window.GioCookieCartPopup.init();
      } else {
        window.UpsellPlusCartPopup?._root?.unmount();
        const script = document.createElement('script');
        script.src = rendererUrl;
        script.onload = () => { rendererLoaded = true; };
        script.onerror = () => { clearTimeout(timeout); window.removeEventListener('gio-cookie-popup-ready', ready); reject(new Error('Popup unavailable')); };
        document.body.append(script);
      }
    });
  }

  function clickOriginal(button) {
    busy = false;
    activeButton?.removeAttribute('aria-busy');
    replay = true;
    navigating = true;
    window.gioCookiePopupResume = true;
    button.click();
    replay = false;
    setTimeout(() => { navigating = false; window.gioCookiePopupResume = false; }, 8000);
  }

  document.addEventListener('click', async event => {
    const button = event.target instanceof Element && event.target.closest(checkoutSelector);
    if (!button || !button.closest('cart-drawer') || replay || navigating) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    activeButton = button;
    uncovered = button.matches('[data-checkout-without-coverage-link]');
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!await activate()) {
        unmount();
        clickOriginal(button);
        return;
      }
      // Release the drawer focus trap before the popup receives any pointer/touch input.
      // Otherwise its first outside tap is consumed by the drawer, especially on iOS.
      const drawer = button.closest("cart-drawer");
      if (drawer?.open) await drawer.hide();
      replay = true;
      button.click();
      replay = false;
      button.removeAttribute('aria-busy');
    } catch (_) {
      unmount();
      clickOriginal(button);
    }
  }, true);

  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      navigating = false;
      replay = false;
      busy = false;
      window.gioCookiePopupResume = false;
      activeButton?.removeAttribute('aria-busy');
    }
  });

  window.addEventListener('gio-cookie-popup-cancel', () => {
    unmount();
    busy = false;
    activeButton?.removeAttribute('aria-busy');
    document.querySelector('cart-drawer')?.show();
  });

  window.addEventListener('gio-cookie-popup-complete', () => {
    unmount();
    const drawer = document.querySelector('cart-drawer');
    const oldForm = drawer.querySelector('form[action="/cart"]');
    let finished = false;
    function attempt() {
      if (finished || drawer.querySelector('form[action="/cart"]') === oldForm) return;
      const selector = uncovered ? '[data-checkout-without-coverage-link]' : '[data-route-cloned-button]';
      const button = drawer.querySelector(selector);
      if (!button || button.disabled) return;
      finished = true;
      observer.disconnect();
      clearInterval(interval);
      clickOriginal(button);
    }
    const observer = new MutationObserver(attempt);
    observer.observe(drawer, {childList: true, subtree: true});
    const interval = setInterval(attempt, 100);
    setTimeout(() => {
      observer.disconnect();
      clearInterval(interval);
      if (!finished) {
        finished = true;
        const selector = uncovered ? '[data-checkout-without-coverage-link]' : '[data-route-cloned-button]';
        clickOriginal(drawer.querySelector(selector) || activeButton);
      }
    }, 8000);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  });
})();

